export default class UIError extends Error {
	displayMessage: string;

	constructor(displayMessage: string) {
		super();
		this.displayMessage = displayMessage;
	}
}
